import { useCallback, useEffect } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getLiveStatusSettings } from '../../services/settingsService';
import { apiParamsState } from '../../storage/app';
import {
  editingLiveStatusSettingsState,
  liveStatusSettingsState,
  loadingLiveStatusSettingsState,
  updateLiveStatusSettingsState,
} from '../../storage/settings';
import useUpdateEffect from '../../hooks/useUpdateEffect';

function LiveStatusSettingsProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setLiveStatusSettings = useSetRecoilState(liveStatusSettingsState);
  const updateLiveStatusSettings = useRecoilValue(updateLiveStatusSettingsState);
  const resetUpdateLiveStatusSettings = useResetRecoilState(updateLiveStatusSettingsState);
  const resetEditingLiveStatusSettings = useResetRecoilState(editingLiveStatusSettingsState);
  const setLoadingLiveStatusSettings = useSetRecoilState(loadingLiveStatusSettingsState);

  const loadLiveStatusSettings = useCallback(async () => {
    const invalid = !apiParams?.clientId || !apiParams?.subClientId;
    if (invalid) return;

    const { liveStatusSettings, error } = await getLiveStatusSettings(apiParams.clientId, apiParams.subClientId);
    if (!error && liveStatusSettings) {
      setLiveStatusSettings(liveStatusSettings);
    } else {
      setLiveStatusSettings(undefined);
    }
  }, [apiParams?.clientId, apiParams?.subClientId, setLiveStatusSettings]);

  useEffect(() => {
    setLoadingLiveStatusSettings(true);
    loadLiveStatusSettings().finally(() => {
      setLoadingLiveStatusSettings(false);
    });
  }, [apiParams?.clientId, apiParams?.subClientId, loadLiveStatusSettings, setLoadingLiveStatusSettings]);

  useUpdateEffect(() => {
    if (!updateLiveStatusSettings) return;

    loadLiveStatusSettings().finally(() => {
      resetUpdateLiveStatusSettings();
      resetEditingLiveStatusSettings();
    });
  }, [updateLiveStatusSettings]);

  return null;
}

export default LiveStatusSettingsProvider;
